/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { Amplify } from 'aws-amplify'
// Import global styles.
// import 'normalize.css'
import './src/styles/grids.css'
import './src/styles/global.css'
import './src/styles/ckeditor.css'

import client from './apollo-client'
import config from './config'

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      loginWith: {
        username: true,
        email: true,
      },
    },
  },
})

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
)

export const onInitialClientRender = () => {
  setTimeout(() => {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-PLZRKVH');
  }, 4000); // Diferido 4 segundos para evitar penalización First Contentful Paint
}

export default {}
